import { FilteredAccount } from './client-accounts.interface';
import { IRAOptions, IRATypes } from './ira-types';

export enum TransactionTypesEnum {
  EXISTING = 'EXISTING',
  NEW_ACCOUNT = 'NEW_ACCOUNT',
  FORCED_NEW_ACCOUNT = 'FORCED_NEW_ACCOUNT',
  UNKNOWN = 'UNKNOWN',
}

export enum TransactionTypeStrings {
  EXISTING = 'Existing Account',
  NEW_ACCOUNT = 'New Account',
  FORCED_NEW_ACCOUNT = 'Forced New Account',
  UNKNOWN = 'Unknown',
}

export interface ISelectedClientAccountsState {
  transferFrom: {
    selectedAccounts: ISelectedAccount[];
  };
  transferTo: {
    hasEligibleExistingAccount: boolean;
    iraOption: IRAOptions;
    iraType: IRATypes;
    selectedAccount: ISelectedAccount;
  };
  transactionType: TransactionTypesEnum;
}

export interface ISelectedAccount {
  accountData: FilteredAccount;
  accountNumber: string;
  index: string;
  accountType?: string;
  listIndex?: string;
}

export interface IUserInputAccount {
  accountNumber: string;
  accountName: string;
}

export type CurrentInputAccount = ISelectedAccount | IUserInputAccount;

export const Move_To_New = new Set([
  TransactionTypesEnum.FORCED_NEW_ACCOUNT,
  TransactionTypesEnum.NEW_ACCOUNT,
]);
